module.exports = "<svg id=70ca0a72-d1d3-49fd-9b11-c4675d54798c data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Info</title><path d=M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3Zm0,17a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z /><path d=M12,9.21a.76.76,0,0,0-.75.75v7.82a.75.75,0,0,0,1.5,0V10A.76.76,0,0,0,12,9.21Z /><circle cx=12 cy=6.97 r=0.75 /></svg>";


//////////////////
// WEBPACK FOOTER
// ../~/html-loader!../~/@printos/gazelle/src/extensions/grid/images/info.svg
// module id = 165
// module chunks = 0